import { EntityAppearanceType } from '@/api/generated/api.enum';
import type { Components } from '@/api/generated/api';
import { APPEARANCE_ICONS, DEFAULT_APPEARANCE_COLOR } from './appearance.constants';
import type { TEntityAppearance } from './entityAppearance.types';

export const appearanceFromDto = (appearance?: Components.Schemas.EntityAppearanceDto | null): TEntityAppearance => {
  const backgroundColor = appearance?.backgroundColor ?? DEFAULT_APPEARANCE_COLOR;
  switch (appearance?.type) {
    case EntityAppearanceType.emoji:
      if (appearance.key && appearance.emojiUnicode) {
        return {
          type: EntityAppearanceType.emoji,
          key: appearance.key,
          unicode: appearance.emojiUnicode,
          backgroundColor,
        };
      }
      break;
    case EntityAppearanceType.icon: {
      const key = APPEARANCE_ICONS.find((icon) => icon === appearance.key);
      if (key) return { type: EntityAppearanceType.icon, key, backgroundColor };
      break;
    }
    case EntityAppearanceType.image:
      if (appearance.imageUrl) return { type: EntityAppearanceType.image, source: appearance.imageUrl };
      break;
  }
  return { type: EntityAppearanceType.text, backgroundColor };
};

export const appearancesEqual = (left: TEntityAppearance, right: TEntityAppearance): boolean => {
  if (left.type === EntityAppearanceType.image || right.type === EntityAppearanceType.image) {
    return (
      left.type === EntityAppearanceType.image &&
      right.type === EntityAppearanceType.image &&
      left.source === right.source
    );
  }
  return (
    left.type === right.type &&
    left.backgroundColor.toUpperCase() === right.backgroundColor.toUpperCase() &&
    (left.type === EntityAppearanceType.text || (right.type !== EntityAppearanceType.text && left.key === right.key))
  );
};

export const appearanceToDto = (
  appearance: Exclude<TEntityAppearance, { type: 'image' }>,
): Components.Schemas.UpdateEntityAppearanceDto => ({
  type: appearance.type,
  backgroundColor: appearance.backgroundColor,
  ...(appearance.type !== EntityAppearanceType.text ? { key: appearance.key } : {}),
});
